module.exports = __webpack_public_path__ + "static/media/traffic-planned.5f4bf657.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/traffic-planned.svg
// module id = 901
// module chunks = 0